import styled from 'styled-components';

export default styled.table`
  margin: 1rem;
`;
